import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/clock_icon.svg'
import _imports_1 from '@/assets/icons/paper_plane_icon.svg'


const _hoisted_1 = { class: "payment-card" }
const _hoisted_2 = { class: "plan-name-text" }
const _hoisted_3 = { class: "monetary-text" }
const _hoisted_4 = { class: "download-pdf-card" }
const _hoisted_5 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "payment-screen",
    style: _normalizeStyle({
      display: $props.showScreen ? 'flex' : 'none'
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createStaticVNode("<img src=\"" + _imports_0 + "\" data-v-2fd8fb14><div style=\"height:var(--semantic-size-semantic-spacing-stack-200, 16px);\" data-v-2fd8fb14></div><p class=\"big-bold-text\" data-v-2fd8fb14>Aguardando pagamento</p><div style=\"height:var(--semantic-size-semantic-spacing-stack-025, 2px);\" data-v-2fd8fb14></div><p class=\"small-muted-text\" data-v-2fd8fb14>A renovação será efetivada quando o pagamento for confirmado.</p><div style=\"height:var(--semantic-size-semantic-spacing-stack-300, 24px);\" data-v-2fd8fb14></div>", 6)),
      _createElementVNode("p", _hoisted_2, "Plano " + _toDisplayString($setup.reqRenewBenCardsPlanStore.benefitsCardsPlan?.getPlanName()), 1 /* TEXT */),
      _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-025, 2px)"} }, null, -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_3, "R$ " + _toDisplayString($setup.FormatUtils.money($setup.reqRenewBenCardsPlanStore.invoice?.getAmount())), 1 /* TEXT */),
      _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-300, 24px)"} }, null, -1 /* HOISTED */)),
      ($setup.reqRenewBenCardsPlanStore.invoice?.getBrCode())
        ? (_openBlock(), _createBlock($setup["QRCode"], {
            key: 0,
            value: $setup.reqRenewBenCardsPlanStore.invoice!.getBrCode()!
          }, null, 8 /* PROPS */, ["value"]))
        : _createCommentVNode("v-if", true),
      _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-300, 24px)"} }, null, -1 /* HOISTED */)),
      _createVNode($setup["CommonButton"], {
        icon: $setup.Icons.imported.faCopy,
        text: "Copiar código Pix",
        onClick: _cache[0] || (_cache[0] = () => {
          $setup.DOMUtils.copyTextToClipboard($setup.reqRenewBenCardsPlanStore.invoice?.getBrCode());
          $setup.commonToast?.open({
            text: 'Código copiado para a área de transferência!',
          });
        })
      }, null, 8 /* PROPS */, ["icon"]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-200, 16px)"} }, null, -1 /* HOISTED */)),
      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "small-muted-text" }, [
        _createTextVNode("Pix Intermediado pela "),
        _createElementVNode("b", { class: "small-bold-text" }, "Starkbank")
      ], -1 /* HOISTED */))
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-400, 32px)"} }, null, -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_4, [
      _cache[9] || (_cache[9] = _createStaticVNode("<img src=\"" + _imports_1 + "\" data-v-2fd8fb14><p class=\"big-bold-text\" data-v-2fd8fb14>Precisa enviar pro financeiro aprovar?</p><div style=\"height:var(--semantic-size-semantic-spacing-stack-025, 2px);\" data-v-2fd8fb14></div><p class=\"small-bold-text\" data-v-2fd8fb14>Baixe o PDF de pagamento para enviar!</p><div style=\"height:21px;\" data-v-2fd8fb14></div>", 5)),
      _createVNode($setup["CommonButton"], {
        icon: $setup.Icons.imported.faCopy,
        action: "secondary",
        type: "outlined",
        text: "Copiar link de pagamento",
        onClick: _cache[1] || (_cache[1] = () => {
          $setup.DOMUtils.copyTextToClipboard($setup.reqRenewBenCardsPlanStore.invoice?.getLink());
          $setup.commonToast?.open({
            text: 'Link copiado para a área de transferência!',
          });
        })
      }, null, 8 /* PROPS */, ["icon"])
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"height":"48px"} }, null, -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_5, [
      _createVNode($setup["CommonButton"], {
        onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$emit('close'); $setup.reqRenewBenCardsPlanStore.$reset();}),
        type: "outlined",
        text: "Fechar",
        action: "secondary"
      })
    ])
  ], 4 /* STYLE */))
}